import React, { useEffect, useState } from 'react';
import Header from '../../Components/Header';
import Loader from '../../Loader';
import { NewsNotificationServices, NewsNotificationUpdateServices } from '../../Services/profile/profileservice';
import { showErrorToast } from '../../utils/toastUtils';

const NewsNotification = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [newsData, setNewsData] = useState([]);
    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
        next_page_url: null,
        prev_page_url: null
    });

    const fetchNews = async (page = 1) => {
        try {
            setIsLoading(true);

            const response = await NewsNotificationServices(page);

            if (response?.status?.code === 200) {
                setNewsData(response?.data || []);

                setPagination({
                    current_page: response.pagination.current_page,
                    last_page: response.pagination.last_page,
                    next_page_url: response.pagination.next_page_url,
                    prev_page_url: response.pagination.prev_page_url
                });
            } else {
                showErrorToast("Failed to load news");
            }
        } catch (error) {
            console.error("Error:", error);
            showErrorToast("Something went wrong!");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const updateNewsStatus = async () => {
            try {
                await NewsNotificationUpdateServices();
            } catch (error) {
                console.error("Update Service Error:", error);
            }
        };
        updateNewsStatus();
        fetchNews(1);
    }, []);

    const handleNext = () => {
        if (pagination.next_page_url) {
            fetchNews(pagination.current_page + 1);
        }
    };

    const handlePrev = () => {
        if (pagination.prev_page_url) {
            fetchNews(pagination.current_page - 1);
        }
    };

    return (
        <>
            {isLoading && <Loader />}

            <Header heading={'News Notifications'} />

            <div className="flex justify-center">
                <div className="p-4 space-y-3 w-full">
                    {newsData.length === 0 ? (
                        <div className="text-center py-4 text-gray-500">
                            No News Available
                        </div>
                    ) : (
                        newsData.map((item) => (
                            <div
                                key={item.id}
                                className="w-full border rounded-lg p-3 text-sm font-medium shadow-sm"
                                style={{
                                    borderLeftWidth: '8px',
                                    borderLeftColor: item.colorCode || '#4CAF50',
                                    backgroundColor: `${item.colorCode || '#4CAF50'}20` // Light background with 10% opacity
                                }}
                            >
                                <div
                                    className="text-black"
                                    // style={{ color: item.colorCode || '#4CAF50' }}
                                    dangerouslySetInnerHTML={{ __html: item.news }}
                                />
                            </div>
                        ))
                    )}

                    {/* Pagination Buttons */}
                    {newsData.length > 0 && (
                        <div className="flex justify-center items-center gap-4 pt-4">
                            <button
                                onClick={handlePrev}
                                disabled={!pagination.prev_page_url}
                                className={`px-4 py-2 rounded-md text-white ${
                                    pagination.prev_page_url
                                        ? "bg-blue-600 hover:bg-blue-700"
                                        : "bg-gray-400 cursor-not-allowed"
                                }`}
                            >
                                Previous
                            </button>

                            <span className="text-sm text-gray-600">
                                Page {pagination.current_page} of {pagination.last_page}
                            </span>

                            <button
                                onClick={handleNext}
                                disabled={!pagination.next_page_url}
                                className={`px-4 py-2 rounded-md text-white ${
                                    pagination.next_page_url
                                        ? "bg-blue-600 hover:bg-blue-700"
                                        : "bg-gray-400 cursor-not-allowed"
                                }`}
                            >
                                Next
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default NewsNotification;
